import { type Environment } from '../app/app.config';
import { environment as defaultEnvironment } from './environment.defaults';

//  Configuration for the personal 'gstanculeanu' dev stage on AWS.
//  Not committed — see backend/deploy-dev/deploy-gstanculeanu.md.
export const environment: Environment = {
  ...defaultEnvironment,
  production: true,
  type: 'production',
  cognitoRegion: 'eu-west-1',
  cognitoDomain: 'gstanculeanu-auth.gstanculeanu.sandbox.bizzdesign.dev',
  cognitoCallbackUrl: 'https://gstanculeanu.sandbox.bizzdesign.dev',
  cognitoUserPoolId: 'eu-west-1_t6LWh2GaU',
  cognitoClientId: 'eug5d0aps7lkh0d0fnrep43g6',
  configUrl:
    'https://gstanculeanu-rest-api.gstanculeanu.sandbox.bizzdesign.dev/config?tenantCode=gstanculeanu',
  appSyncUrl:
    'https://gstanculeanu-api.gstanculeanu.sandbox.bizzdesign.dev/graphql',
  appSyncRealtimeUrl:
    'wss://gstanculeanu-api.gstanculeanu.sandbox.bizzdesign.dev/graphql/realtime',
  collaborationServers: {
    signalingServers: [
      'wss://gstanculeanu-ws-api.gstanculeanu.sandbox.bizzdesign.dev',
    ],
  },
  posthogConfig: {
    trackingEnabled: false,
    group: 'internal',
    tenantId: 'gstanculeanu',
    posthogApiKey: 'phc_GsXYjP2DNSIFadysuOvDVOGyatwDaEQA8x9GiCYqZ7a',
    posthogUiHost: 'https://eu.posthog.com',
    posthogApiHost: 'https://t.svc.unify.cloud',
  },
  aiWorkflowsConfig: {
    // Deployed AiWorkflows-gstanculeanu (no custom domain yet). The `/ai` suffix
    // is required. Point at the local dev-server port instead to drive a local lambda.
    baseUrl: 'https://yw26mposia.execute-api.eu-west-1.amazonaws.com/api/ai',
  },
  featureFlags: {
    ...defaultEnvironment.featureFlags,
    aiSearchEnabled: true,
    manageAttributesEnabled: true,
    integrationsEnabled: true,
    workspaceOverviewEnabled: true,
    customTemplatesEnabled: true,
    addToFrameWithoutSelectionEnabled: true,
    dataImportV2Enabled: true,
    addViewToFrameEnabled: true,
    createWorkspaceWithSourcesEnabled: true,
  },
};
